module.exports = __webpack_public_path__ + "static/media/shader.662c008c.vert";


//////////////////
// WEBPACK FOOTER
// ./src/lib/vendor/postprocessing/materials/glsl/god-rays/shader.vert
// module id = 286
// module chunks = 0